import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { bindActionCreators } from "redux";
import { FilterContext } from "../../layouts/market/MainRouter.jsx";
import * as actions from "../../store/actions/actions.js";
import { expirationTimesSelector, selectedExpirationTimeSelector } from "../../store/selectors/dateUtilsSelectors";
import { selectedTokenPairSelector } from "../../store/selectors/tokensSelectors";
import { web3AccountLoadedSelector } from "../../store/selectors/web3Selectors";

class MenuPanel extends React.Component {
  componentDidMount() {
    document.documentElement.classList.remove("nav-open");

    // Array.from(document.getElementsByClassName('noBorder')).forEach(ni => {
    //   ni.addEventListener('mouseenter',event => {
    //     event.target.querySelector('.hoverNavItem').classList.add('hoverNavItemVisible');
    //   });
    //   ni.addEventListener('mouseleave',event => {
    //     event.target.querySelector('.hoverNavItem').classList.remove('hoverNavItemVisible');
    //   });
    //   ni.addEventListener('click',event => {
    //     if(event.target.classList.contains('noBorder')){
    //       const anchorLink = event.target.querySelector('a');
    //       anchorLink.click();
    //     }
    //   });

    // })
  }

  render() {
    return (
      // <table className="table">
      //   <tbody>
      //     <tr>

      //       <td className="noBorder">
      //         <NavLink
      //           to={"/trade/eth-usd/all"}
      //           className="simple-text logo-normal clickable-row"
      //           activeClassName="activeNav"
      //           //onClick={() => this.props.actions.expirationTimeSelected({ timestamp: "all", sidebarFormat: "All Expirations", urlFormat: "all" })}
      //         >
      //           Trade
      //         </NavLink>
      //         <div className="hoverNavItem"></div>
      //       </td>
      //       <td className="noBorder">
      //         <NavLink
      //           to={"/pool/eth-usd/all"}
      //           className="simple-text logo-normal clickable-row"
      //           activeClassName="activeNav"
      //           //onClick={() => this.props.actions.expirationTimeSelected({ timestamp: "all", sidebarFormat: "All Expirations", urlFormat: "all" })}
      //         >
      //           Pool
      //         </NavLink>
      //         <div className="hoverNavItem"></div>
      //       </td>
      //       <td className="noBorder">
      //         <NavLink
      //           to={"/account"}
      //           className="simple-text logo-normal clickable-row"
      //           activeClassName="activeNav"
      //           //onClick={() => this.props.actions.expirationTimeSelected({ timestamp: "all", sidebarFormat: "All Expirations", urlFormat: "all" })}
      //         >
      //           Account
      //         </NavLink>
      //         <div className="hoverNavItem"></div>
      //       </td>

      //     </tr>
      //   </tbody>
      // </table>
      <FilterContext.Consumer>
        {({ selectedExpirationTime }) => {
          return (
            <div className="nav">
              <NavLink
                to={`/trade/eth-usd/${selectedExpirationTime.urlFormat}`}
                // isActive={(match, location) => {
                //   console.log("is active");
                //   return location.pathname.includes("trade");
                // }}
                className={({ isActive, isPending }) =>
                  !window.location.pathname.includes("trade") ? "navItem" : window.location.pathname.includes("trade") ? "navItem activeNav" : ""
                }
                // className={`navItem${window.location.pathname.includes("trade") ? " activeNav" : ""}`}
                // activeClassName="activeNav"
                //onClick={() => this.props.actions.expirationTimeSelected({ timestamp: "all", sidebarFormat: "All Expirations", urlFormat: "all" })}
              >
                <span>Trade</span>
              </NavLink>
              <NavLink
                to={`/pool/eth-usd/${selectedExpirationTime.urlFormat}`}
                className={({ isActive, isPending }) =>
                  !window.location.pathname.includes("pool") ? "navItem" : window.location.pathname.includes("pool") ? "navItem activeNav" : ""
                }
                // className={`navItem${window.location.pathname.includes("pool") ? " activeNav" : ""}`}
                // activeClassName="activeNav"
                //onClick={() => this.props.actions.expirationTimeSelected({ timestamp: "all", sidebarFormat: "All Expirations", urlFormat: "all" })}
              >
                Pool
              </NavLink>
              <NavLink
                to={"/portfolio"}
                className={({ isActive, isPending }) =>
                  !window.location.pathname.includes("portfolio") ? "navItem" : window.location.pathname.includes("portfolio") ? "navItem activeNav" : ""
                }
                // className={`navItem${window.location.pathname.includes("portfolio") ? " activeNav" : ""}`}
                // activeClassName="activeNav"
              >
                Portfolio
              </NavLink>
              <NavLink
                to={"/lend"}
                className={({ isActive, isPending }) =>
                  !window.location.pathname.includes("lend") ? "navItem" : window.location.pathname.includes("lend") ? "navItem activeNav" : ""
                }
                // className={`navItem${window.location.pathname.includes("lend") ? " activeNav" : ""}`}
                // activeClassName="activeNav"
                //onClick={() => this.props.actions.expirationTimeSelected({ timestamp: "all", sidebarFormat: "All Expirations", urlFormat: "all" })}
              >
                Lend
              </NavLink>
              {/* <NavLink
          to={"/account"}
          className="navItem"
          activeClassName="activeNav"
          //onClick={() => this.props.actions.expirationTimeSelected({ timestamp: "all", sidebarFormat: "All Expirations", urlFormat: "all" })}
        >
          Account
        </NavLink> */}
            </div>
          );
        }}
      </FilterContext.Consumer>
    );
  }
}

MenuPanel.propTypes = {
  web3AccountLoaded: PropTypes.bool,
  expirationTimes: PropTypes.array,
  selectedTokenPair: PropTypes.object,
  selectedExpirationTime: PropTypes.object,
  actions: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {
    web3AccountLoaded: web3AccountLoadedSelector(state),
    expirationTimes: expirationTimesSelector(state),
    selectedExpirationTime: selectedExpirationTimeSelector(state),
    selectedTokenPair: selectedTokenPairSelector(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MenuPanel);
